import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { useAxiosInstance } from "../../../services/Interceptor";
import {
  deleteAccoladeAction,
  fetchAccolades,
} from "../../../store/AthleteActions";
import { useDispatch } from "react-redux";

export default function DeleteAccolade({
  deleteAccoladeOpen,
  closeDeleteAccolade,
  accoladeId,
  athleteId,
  onDeleteSuccess,
}) {
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();

  const deleteAccolade = async () => {
    try {
      await dispatch(deleteAccoladeAction(apiInstance, accoladeId));

      // Refresh accolades after successful deletion
      if (athleteId) {
        await dispatch(fetchAccolades(apiInstance, athleteId));
      }

      // Call callback if provided
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }

      closeDeleteAccolade();
    } catch (error) {
      console.error("Failed to delete accolade:", error);
      // You might want to show an error toast here
    }
  };

  return (
    <Dialog
      open={deleteAccoladeOpen}
      onClose={closeDeleteAccolade}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-800/50 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg shadow-lg">
          <div className="p-6">
            <DialogTitle className="text-lg font-semibold mb-4">
              Delete Accolade?
            </DialogTitle>
            <form>
              <p className="mb-4 text-sm text-gray-600 pb-3">
                Are you sure you want to delete the selected accolade?
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={closeDeleteAccolade}
                  className="px-4 py-2 rounded border"
                  type="button"
                >
                  Cancel
                </button>
                <button
                  onClick={deleteAccolade}
                  className="px-4 py-2 bg-red-600 text-white rounded"
                  type="button"
                >
                  Delete
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
